// TODO (post–niveau 6): performanceBenchmarks — aspirational elite skala, opt-in

export interface LearningBenchmarkTier {
  minWords: number;
  label: string;
  shortLabel?: string;
}

export interface CheckpointLearningBenchmark {
  checkpointId: string;
  displayMax: number;
  contextLine: string;
  tiers: LearningBenchmarkTier[];
}

const BENCHMARKS: CheckpointLearningBenchmark[] = [
  {
    checkpointId: 'checkpoint-after-grundniveau',
    displayMax: 45,
    contextLine: 'For dit niveau — ikke sammenlignet med øvede typister.',
    tiers: [
      { minWords: 0, label: 'God start', shortLabel: 'Start' },
      { minWords: 13, label: 'Solidt for grundniveau', shortLabel: 'Solidt' },
      { minWords: 23, label: 'Stærkt — du har fat i det', shortLabel: 'Stærkt' },
      { minWords: 33, label: 'Fremragende for dette niveau', shortLabel: 'Top' },
    ],
  },
  {
    checkpointId: 'checkpoint-after-niveau-1',
    displayMax: 50,
    contextLine: 'For dit niveau — ikke sammenlignet med øvede typister.',
    tiers: [
      { minWords: 0, label: 'God start', shortLabel: 'Start' },
      { minWords: 15, label: 'Solidt for niveau 1', shortLabel: 'Solidt' },
      { minWords: 27, label: 'Stærkt på nye taster', shortLabel: 'Stærkt' },
      { minWords: 39, label: 'Fremragende for dette niveau', shortLabel: 'Top' },
    ],
  },
  {
    checkpointId: 'checkpoint-after-niveau-2',
    displayMax: 52,
    contextLine: 'For dit niveau — ikke sammenlignet med øvede typister.',
    tiers: [
      { minWords: 0, label: 'God start', shortLabel: 'Start' },
      { minWords: 16, label: 'Solidt for niveau 2', shortLabel: 'Solidt' },
      { minWords: 29, label: 'Stærkt — god rytme', shortLabel: 'Stærkt' },
      { minWords: 41, label: 'Fremragende for dette niveau', shortLabel: 'Top' },
    ],
  },
  {
    checkpointId: 'checkpoint-after-niveau-3',
    displayMax: 54,
    contextLine: 'For dit niveau — ikke sammenlignet med øvede typister.',
    tiers: [
      { minWords: 0, label: 'God start', shortLabel: 'Start' },
      { minWords: 17, label: 'Solidt for niveau 3', shortLabel: 'Solidt' },
      { minWords: 31, label: 'Stærkt — god rytme', shortLabel: 'Stærkt' },
      { minWords: 45, label: 'Fremragende for dette niveau', shortLabel: 'Top' },
    ],
  },
  {
    checkpointId: 'checkpoint-after-niveau-4',
    displayMax: 55,
    contextLine: 'For dit niveau — ikke sammenlignet med øvede typister.',
    tiers: [
      { minWords: 0, label: 'God start', shortLabel: 'Start' },
      { minWords: 16, label: 'Solidt for hele alfabetet', shortLabel: 'Solidt' },
      { minWords: 29, label: 'Stærkt på alfabetet', shortLabel: 'Stærkt' },
      { minWords: 43, label: 'Fremragende for dette niveau', shortLabel: 'Top' },
    ],
  },
  {
    checkpointId: 'checkpoint-after-niveau-5',
    displayMax: 58,
    contextLine: 'For dit niveau — ikke sammenlignet med øvede typister.',
    tiers: [
      { minWords: 0, label: 'God start', shortLabel: 'Start' },
      { minWords: 18, label: 'Solidt for niveau 5', shortLabel: 'Solidt' },
      { minWords: 31, label: 'Stærkt med case og tegn', shortLabel: 'Stærkt' },
      { minWords: 45, label: 'Fremragende for dette niveau', shortLabel: 'Top' },
    ],
  },
  {
    checkpointId: 'checkpoint-after-niveau-6',
    displayMax: 68,
    contextLine: 'For dit niveau — ikke sammenlignet med øvede typister.',
    tiers: [
      { minWords: 0, label: 'God start', shortLabel: 'Start' },
      { minWords: 18, label: 'Solidt for fuld blindskrift', shortLabel: 'Solidt' },
      { minWords: 33, label: 'Stærkt — god flydighed', shortLabel: 'Stærkt' },
      { minWords: 48, label: 'Fremragende for dette niveau', shortLabel: 'Top' },
    ],
  },
];

const MAP = new Map(BENCHMARKS.map((b) => [b.checkpointId, b]));

export function getCheckpointBenchmark(
  checkpointId: string,
): CheckpointLearningBenchmark | undefined {
  return MAP.get(checkpointId);
}
